import { Logger } from '@inlight-media/linfox-utils';

const logger = new Logger({
  accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
  environment: process.env.REACT_APP_ROLLBAR_ENV || 'development',
});

export { logger };
